import type { PropertiesNullable } from '@@types/helpers'
import EntityBase from '@app/entities/EntityBase'
import { EntityHealthCheckAttribute, createEntities } from '@app/entities/index'
import type {
  HealthCheckAttribute,
  HealthCheckPlatformStatus,
  HealthCheckPlatformStatusReason,
  Maybe
} from '@server/graphql/typeDefs/types'
import { HealthCheckStatus } from '@server/graphql/typeDefs/types'
import { HealthCheckLabelTranslation } from './EntityHealthCheckDomainStatusReason'

export default class EntityHealthCheckPlatformStatusReason
  extends EntityBase
  implements PropertiesNullable<HealthCheckPlatformStatusReason>
{
  name: Maybe<string> = null
  status: Maybe<HealthCheckStatus> = null
  statusSince: Maybe<string> = null
  lastCheckDate: Maybe<string> = null
  attributes: Maybe<HealthCheckAttribute[]> = null

  constructor(data: Partial<HealthCheckPlatformStatus>) {
    super()
    Object.assign(this, data)
  }

  /**
   * Return the attributes entities.
   */
  getAttributes(): Maybe<EntityHealthCheckAttribute[]> {
    if (!this.attributes) {
      return null
    }

    return createEntities<HealthCheckAttribute, EntityHealthCheckAttribute>(
      EntityHealthCheckAttribute,
      this.attributes
    )
  }

  /**
   * Return true if the reason status is unknown.
   */
  isStatusUnknown(): boolean {
    if (!this.status) {
      return false
    }

    return this.status === HealthCheckStatus.Unknown
  }

  /**
   * Return true if the reason status is warning or failure.
   */
  isWarningOrFailure(): boolean {
    if (!this.status) {
      return false
    }

    return [HealthCheckStatus.Warning, HealthCheckStatus.Failure].includes(
      this.status
    )
  }

  /**
   * Return the label according to the status of the reason.
   */
  statusLabelTranslation(): Maybe<HealthCheckLabelTranslation> {
    if (this.isStatusUnknown()) {
      return HealthCheckLabelTranslation.unknownDetails
    }

    // fail status if warn | failure
    if (this.isWarningOrFailure()) {
      return HealthCheckLabelTranslation.details
    }

    // otherwise, success
    return HealthCheckLabelTranslation.successDetails
  }
}
